function normalizePath(pathname = '') {
  if (!pathname || pathname === '/') return '/';

  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}

function pathsMatch(currentPath, targetPath) {
  const current = normalizePath(currentPath);
  const target = normalizePath(targetPath);

  if (target === '/') {
    return current === '/';
  }

  if (!current.startsWith(target)) {
    return false;
  }

  if (current.length === target.length) {
    return true;
  }

  return current.charAt(target.length) === '/';
}

function toPathname(value) {
  if (!value) return '/';

  if (value.startsWith('http://') || value.startsWith('https://')) {
    try {
      return new URL(value).pathname;
    } catch (_error) {
      return value;
    }
  }

  try {
    return new URL(value, window.location.origin).pathname;
  } catch (_error) {
    return value;
  }
}

function resolveCurrentPath() {
  const pathname = window.location.pathname || '/';
  const appsIndex = pathname.indexOf('/apps/');

  if (appsIndex === -1) {
    return pathname;
  }

  const suffix = pathname.slice(appsIndex + '/apps/'.length);
  const segments = suffix.split('/').filter(Boolean);

  if (!segments.length) {
    return '/';
  }

  // Remove the app handle segment
  segments.shift();

  return segments.length ? `/${segments.join('/')}` : '/';
}

function updateShopifyNavSelection() {
  const navMenu = document.querySelector('ui-nav-menu');

  if (!navMenu) return;

  const currentPath = resolveCurrentPath();

  navMenu.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href');

    if (!href) {
      link.removeAttribute('selected');
      return;
    }

    const defaultHrefAttr = link.getAttribute('data-default-href');
    const defaultHref = defaultHrefAttr || href;
    const pathname = toPathname(href);
    const defaultPathname = toPathname(defaultHref);

    let matchPaths = [];
    const dataMatch = link.getAttribute('data-match-paths');

    if (dataMatch) {
      try {
        const parsed = JSON.parse(dataMatch);
        if (Array.isArray(parsed)) {
          matchPaths = parsed.filter((value) => typeof value === 'string');
        }
      } catch (_error) {
        // Ignore malformed data-match-paths
      }
    }

    if (!matchPaths.length) {
      matchPaths = [defaultPathname];
    }

    matchPaths.push(defaultPathname, pathname);

    matchPaths = Array.from(
      new Set(matchPaths.map((matchPath) => toPathname(matchPath)))
    );

    const isSelected = matchPaths.some((matchPath) => pathsMatch(currentPath, matchPath));
    const activeClasses = [
      'Polaris-Navigation__Item--selected',
      'Polaris-Navigation--subNavigationActive',
      'Polaris-Navigation--itemLinePointer',
    ];

    if (isSelected) {
      const activeHref = toPathname(currentPath);

      if (activeHref && link.getAttribute('href') !== activeHref) {
        link.setAttribute('href', activeHref);
      }

      link.dataset.activeHref = activeHref;
      link.dataset.active = 'true';
      activeClasses.forEach((className) => link.classList.add(className));
    } else {
      if (link.getAttribute('href') !== defaultHref) {
        link.setAttribute('href', defaultHref);
      }

      delete link.dataset.activeHref;
      delete link.dataset.active;
      activeClasses.forEach((className) => link.classList.remove(className));
    }
  });
}

document.addEventListener('turbolinks:load', updateShopifyNavSelection);
document.addEventListener('turbolinks:render', updateShopifyNavSelection);
